<template>
    <div>
        <div>Api 1 : {{apiStatus1}}</div>
        <div>Api 2 : {{apiStatus2}}</div>
        <div>Api 3 : {{apiStatus3}}</div>
        <div>{{allSuccess}}</div>
    </div>
</template>
<script>
import ApiForTextPromise from "../service/ApiForTestPromise.js";

export default {
    name: "PromiseExample",
    data: function() {
        return {
            apiStatus1: false,
            apiStatus2: false,
            apiStatus3: false,

            allSuccess: 'loading',
        };
    },
    mounted: function() {
        this.connectApi();
    },
    methods: {
        connectApi: function() {
            var book0 = this.apiGetBook(0);
            var book1 = this.apiGetBook(1);
            var book2 = this.apiGetBook(2);

            Promise.all([book0, book1, book2]).then((values) => {
                console.log(values);
                this.apiStatus1 = values[0].data;
                this.apiStatus2 = values[1].data;
                this.apiStatus3 = values[2].data;

                this.allSuccess = 'success';
            }).catch((err) => {
                console.log(err.response);
            });
        },

        apiGetBook: function(id) {
            return ApiForTextPromise.apiGetBook(id);
        },
    },
}
</script>
